import { getCloudflareTrace } from '#pplx/frontend/apps/ask/queries/cloudflare-queries/getCloudflareTrace.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useMemo } from 'react';
export function useGetCountry() {
    const { data: cloudflareTrace } = useQuery({
        queryKey: QueryClientHelper.makeEphemeralQueryKey('cloudflare-trace'),
        queryFn: getCloudflareTrace,
        staleTime: 1e3 * 60, // 1 minute
    });
    return useMemo(() => cloudflareTrace?.loc ?? 'US', [cloudflareTrace]);
}
//# sourceMappingURL=useGetCountry.js.map